import { UseAPI } from './api';
import { Controllers } from '../constants/Controllers'

export async function InsertCreditCard ( Token, Id, Descricao, DisplayNumber, Bandeira, Documento, ExpirationDate, Titular, SecurityNumber )
{
    try
    {
        let request = JSON.stringify( {
            Token
            , Id
            , Descricao
            , DisplayNumber
            , Bandeira
            , Documento
            , ExpirationDate
            , Titular
            , SecurityNumber
        } )

        const response = await UseAPI( Controllers.ControllerAdmin + `CadastrarCartaoWebView`, request )

        return response

    } catch ( err )
    {

    }
}